// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DepartmentsModal_container__wXBb4 {
  min-width: 600px;
  background-color: white;
  padding: 32px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-height: 600px;
  z-index: 10;
}

.DepartmentsModal_header__7FEov {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.DepartmentsModal_header__7FEov h4 {
  margin: 0;
  display: flex;
  gap: 6px;
}

.DepartmentsModal_header__7FEov p {
  margin: 0;
  color: blue;
}

.DepartmentsModal_header__7FEov span {
  cursor: pointer;
}

.DepartmentsModal_table__cNiLc {
  display: flex;
  flex-direction: column;
  height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
}

.DepartmentsModal_tableContent__iG-S7 {
  display: flex;
  padding: 12px 20px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  justify-content: space-between;
  color: #676c7e;
  line-height: 24px;
  &:hover {
    box-shadow: 0px 2px 4px 0px #00000014;
    box-shadow: 0px 6px 20px 0px #00000014;
    background-color: #f6f6f6;
  }
}

.DepartmentsModal_tableHeader__tFaNW {
  padding: 12px 20px;
  height: 20px;
  background-color: #3082f6;
  border-radius: 0 0 8px 8px;
  display: flex;
  justify-content: space-between;
  color: white;
}

.DepartmentsModal_tableHeader__tFaNW > div,
.DepartmentsModal_tableContent__iG-S7 > div {
  width: 100px;
  display: inline-block;
  white-space: normal;
  word-wrap: break-word;
}

.DepartmentsModal_notificationDiv__S3VXi,
.DepartmentsModal_error__EkmAy {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

.DepartmentsModal_error__EkmAy {
  background-color: red;
  border-radius: 8px;
  padding: 10px;
  font-weight: 500;
  margin-top: 1rem;
}
.DepartmentsModal_modalOverlay__feauL {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9; /* To ensure the modal is on top of the overlay */
}
.DepartmentsModal_orgBtn__ulMrU,
.DepartmentsModal_companyBtn__Ls563 {
  background-color: #3082f6;
  border: none;
  padding: 0 16px;
  border-radius: 12px;
  height: 44px;
  color: white;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/departmentsModal/DepartmentsModal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB;IACE,qCAAqC;IACrC,sCAAsC;IACtC,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU,EAAE,iDAAiD;AAC/D;AACA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB","sourcesContent":[".container {\n  min-width: 600px;\n  background-color: white;\n  padding: 32px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  max-height: 600px;\n  z-index: 10;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header h4 {\n  margin: 0;\n  display: flex;\n  gap: 6px;\n}\n\n.header p {\n  margin: 0;\n  color: blue;\n}\n\n.header span {\n  cursor: pointer;\n}\n\n.table {\n  display: flex;\n  flex-direction: column;\n  height: 350px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.tableContent {\n  display: flex;\n  padding: 12px 20px;\n  border: 1px solid #f0f0f0;\n  border-radius: 8px;\n  justify-content: space-between;\n  color: #676c7e;\n  line-height: 24px;\n  &:hover {\n    box-shadow: 0px 2px 4px 0px #00000014;\n    box-shadow: 0px 6px 20px 0px #00000014;\n    background-color: #f6f6f6;\n  }\n}\n\n.tableHeader {\n  padding: 12px 20px;\n  height: 20px;\n  background-color: #3082f6;\n  border-radius: 0 0 8px 8px;\n  display: flex;\n  justify-content: space-between;\n  color: white;\n}\n\n.tableHeader > div,\n.tableContent > div {\n  width: 100px;\n  display: inline-block;\n  white-space: normal;\n  word-wrap: break-word;\n}\n\n.notificationDiv,\n.error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n.error {\n  background-color: red;\n  border-radius: 8px;\n  padding: 10px;\n  font-weight: 500;\n  margin-top: 1rem;\n}\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 9; /* To ensure the modal is on top of the overlay */\n}\n.orgBtn,\n.companyBtn {\n  background-color: #3082f6;\n  border: none;\n  padding: 0 16px;\n  border-radius: 12px;\n  height: 44px;\n  color: white;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DepartmentsModal_container__wXBb4`,
	"header": `DepartmentsModal_header__7FEov`,
	"table": `DepartmentsModal_table__cNiLc`,
	"tableContent": `DepartmentsModal_tableContent__iG-S7`,
	"tableHeader": `DepartmentsModal_tableHeader__tFaNW`,
	"notificationDiv": `DepartmentsModal_notificationDiv__S3VXi`,
	"error": `DepartmentsModal_error__EkmAy`,
	"modalOverlay": `DepartmentsModal_modalOverlay__feauL`,
	"orgBtn": `DepartmentsModal_orgBtn__ulMrU`,
	"companyBtn": `DepartmentsModal_companyBtn__Ls563`
};
export default ___CSS_LOADER_EXPORT___;
